import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const fetchClientsAccounts = createAsyncThunk(
  "accounts/fetchAccounts",
  async ({ clientId, search = "", page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const url = `/account/getAccounts/${clientId}?search=${encodeURIComponent(
        search
      )}&page=${page}&limit=${limit}`;

      const response = await getMethod(url);
      const data = await response.json();

      if (!response.ok || data?.error) {
        return rejectWithValue(data?.error || "Failed to fetch accounts");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

const accountsSlice = createSlice({
  name: "accounts",
  initialState: {
    loading: false,
    error: null,
    accountsList: [],
    accountPagination: {}, 
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchClientsAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientsAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.accountsList = action.payload.data || [];
        state.accountPagination = action.payload.pagination || {};
      })
      .addCase(fetchClientsAccounts.rejected, (state, action) => {
        state.loading = false;
        state.accountsList=[];
        state.accountPagination={};
        state.error = action.payload || "Failed to load accounts";
      });
  },
});

export default accountsSlice.reducer;
